export default {
    title: "O-I",
    support: "Wsparcie",
    dashboard: "Panel"
}